export default [
  // 我的
  {
    path: '/vip',
    component: resolve => require(['@/view/Vip/List'], resolve),
    meta: {
      title: '注册会员',
    }
  },
  // 我的
  {
    path: '/vip/form',
    component: resolve => require(['@/view/Vip/Form'], resolve),
    meta: {
      title: '确认信息',
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/vip.js